import { Warning } from "@phosphor-icons/react";

const AMBER_WASH = "rgba(255, 196, 0, 0.05)";
const AMBER_GLOW =
  "radial-gradient(44% 100% at 50% 0%, rgba(255, 196, 0, 0.20) 0%, rgba(255, 196, 0, 0.10) 49.29%, rgba(255, 196, 0, 0) 100%)";
const AMBER_GLOW_BURN =
  "radial-gradient(53.57% 56.87% at 50% 0%, rgba(255, 196, 0, 0.06) 0%, rgba(255, 196, 0, 0.03) 49.29%, rgba(255, 196, 0, 0) 100%)";
const AMBER_ICON = "#a65f00";
const AMBER_TEXT = "#a65f00";

export interface GiftCardZeroBalanceStripProps {
  message: string;
  subtext?: string;
}

const GiftCardZeroBalanceStrip = ({
  message,
  subtext,
}: GiftCardZeroBalanceStripProps) => {
  return (
    <div
      className="ui-flex ui-w-full ui-flex-col ui-items-start ui-justify-end ui-self-stretch ui-px-5 ui-py-3"
      style={{
        background: `linear-gradient(0deg, ${AMBER_WASH} 0%, ${AMBER_WASH} 100%), ${AMBER_GLOW_BURN}, ${AMBER_GLOW}`,
        backgroundBlendMode: "normal, color-burn, normal",
      }}
    >
      <div className="ui-relative ui-flex ui-w-full ui-items-center ui-gap-2">
        <span className="ui-flex ui-size-6 ui-shrink-0 ui-items-center ui-justify-center">
          <Warning size={22} weight="duotone" style={{ color: AMBER_ICON }} />
        </span>
        <div className="ui-flex ui-min-w-0 ui-flex-1 ui-flex-col">
          <p
            className="ui-w-full ui-break-words ui-text-text-xs-semibold"
            style={{ color: AMBER_TEXT }}
          >
            {message}
          </p>
          {Boolean(subtext) && (
            <p className="ui-w-full ui-break-words ui-text-text-xs-medium ui-text-zinc-500">
              {subtext}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default GiftCardZeroBalanceStrip;
